import { APIPath } from "../constant";
import { BaseService } from "./base";
import { CRUDService } from "./crud";

class Server extends CRUDService {
  constructor() {
    super(APIPath.wakeUpDB);
  }

  start() {
    return BaseService.post(`${APIPath.wakeUpDB}`);
  }
}
const ServerService = new Server();
Object.freeze(ServerService);
export { ServerService };
